import {FC, useEffect, useMemo, useRef, useState} from 'react'
import {
  fetchData,
  formatNumber,
  getEncryptedRoute,
  toasterrormsg,
  useMenuIdPermissions,
} from '../../../../reusable'
import {KTIcon} from '../../../../_metronic/helpers'
import {ToastContainer} from 'react-toastify'
import DataTable from 'react-data-table-component'
import {Link} from 'react-router-dom'
import Select, { CSSObjectWithLabel } from 'react-select'
import {Tr} from '../../../../_metronic/i18n/Tr'

const ViewVendorPaymentManagement: FC = () => {
  let t = Tr()
  const {menuId} = useMenuIdPermissions()

  const [paymentDetailList, setPaymentDetailList] = useState([])
  const [orgPaymentDetailList, setOrgPaymentDetailList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [totalRecords, setTotalRecords] = useState('') as any
  const [limit, setLimit] = useState(10)
  const [offset, setOffset] = useState(0)
  const [totalInsayrRevenue, setTotalInsayrRevenue] = useState('')
  const [totalRevenue, setTotalRevenue] = useState('')

  const currentYear = new Date().getFullYear()
  const [selectedYear, setSelectedYear] = useState(currentYear) as any
  const yearList = Array.from({length: currentYear - 2020 + 1}, (_, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString(),
  }))

  const clearFields = () => {
    setSelectedYear(currentYear)
    yearlyInvoiceListApiCall(currentYear)
    yearlyInvoiceTotalApiCall(currentYear)
  }

  //   Payment detail list api call
  const yearlyInvoiceListApiCall = async (year = selectedYear, limit1?: any, offset1?: any) => {
    let param = {
      year: String(year),
      limit: limit1,
      offset: offset1,
    }

    var res = await fetchData('admin/yearlyinvoice', param)

    if (res.status == '200') {
      var data = res.data.data

      setPaymentDetailList(data)
      setTotalRecords(res.data.totalRecord)
      setOrgPaymentDetailList(data)
    } else {
      toasterrormsg(res.message)
    }
  }

  const yearlyInvoiceTotalApiCall = async (year = selectedYear, limit1?: any, offset1?: any) => {
    let param = {
      year: String(year),
      limit: limit1,
      offset: offset1,
    }

    var res = await fetchData('admin/yearlyInvoiceTotal ', param)

    if (res.status == '200') {
      var data = res.data
      setTotalInsayrRevenue(data.insayrRevenue)
      setTotalRevenue(data.totalRevenue)
    } else {
      toasterrormsg(res.message)
    }
  }

  // search Coupon
  const paymentDetailSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setPaymentDetailList(orgPaymentDetailList)
    } else {
      var tmp: any = orgPaymentDetailList.filter((item: any) => {
        return (
          (item.invoiceCode != null &&
            item.invoiceCode != '' &&
            String(item.invoiceCode).toLocaleLowerCase().includes(text)) ||
          (item.invoiceCreated != null &&
            item.invoiceCreated != '' &&
            String(item.invoiceCreated).toLocaleLowerCase().includes(text)) ||
          (item.totalBooking != null &&
            item.totalBooking != '' &&
            String(item.totalBooking).toLocaleLowerCase().includes(text)) ||
          (item.totalRevenue != null &&
            item.totalRevenue != '' &&
            String(item.totalRevenue).toLocaleLowerCase().includes(text)) ||
          (item.insayrRevenue != null &&
            item.insayrRevenue != '' &&
            String(item.insayrRevenue).toLocaleLowerCase().includes(text))
        )
      })
      setPaymentDetailList(tmp)
    }
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])

    return (
      <div className=' d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
      </div>
    )
  }

  // Define your DataTable columns
  var column = useMemo(
    () => [
      {
        name: t('Invoice Code'),
        cell: (row: any) => (
          <div className='my-3'>
            {row.invoiceCode != '' ? (
              <div className='fw-bold fs-5 text-primary under text-decoration-underline cursor-pointer'>
                <Link
                  to={getEncryptedRoute('../invoicewisevendorpaymentmanagement/', {menuId:menuId})}
                  state={{
                    invoiceCode: row.invoiceCode,
                  }}
                >
                  #{row.invoiceCode != '' ? row.invoiceCode : '-'}
                </Link>
              </div>
            ) : (
              <div className='fw-bold'></div>
            )}
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => Number(row.invoiceCode),
      },

      {
        name: t('Document Name'),
        cell: (row: any) => {
          if (row.documentName == '') {
            return <div className='my-3 fw-bold fs-5'>Total</div>
          }
          const invoiceCode = row.invoiceCode || '' // Get the invoiceCode, or an empty string if not available
          const year = invoiceCode.substring(0, 4) // Extract the first 4 characters as year
          const monthNumber = invoiceCode.substring(4, 6) // Extract the last 2 characters as month

          // Create an array of month names
          const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ]

          // Convert the month number to an integer and map it to the corresponding month name
          const monthName = months[parseInt(monthNumber) - 1] || '-'

          return (
            <div className='my-3'>
              <div className='fw-bold fs-5 text-primary under text-decoration-underline'>
                <Link
                  to={getEncryptedRoute('../invoicewisevendorsbooking/', {menuId:menuId})}
                  state={{
                    invoiceCode: row.invoiceCode,
                  }}
                >
                  {invoiceCode != '' ? `Bookings for ${monthName} ${year}` : '-'}
                </Link>
              </div>
            </div>
          )
        },
        sortable: true,
        selector: (row: any) => String(row.invoiceCode),
        filter: true,
        width: '250px',
      },

      {
        name: t('Invoice Created'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.invoiceCreated != '' ? row.invoiceCreated : '-'}
            </div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.invoiceCreated),
        filter: true,
        width: '222px',
      },

      {
        name: t('Number Of Bookings'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.totalBooking != '' ? row.totalBooking : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.totalBooking),
        filter: true,
        width: '180px',
      },
      {
        name: t('Total Revenue'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.totalRevenue != '' ? formatNumber(parseFloat(row.totalRevenue)) : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.totalRevenue),
        filter: true,
        width: '180px',
      },
      {
        name: t('Insayr Revenue Fee'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.insayrRevenue != '' ? formatNumber(parseFloat(row.insayrRevenue)) : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.insayrRevenue),
        filter: true,
        width: '180px',
      },
      {
        name: t('Percentage Paid'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.percentagePaid != '' ? row.percentagePaid : '-'}
              {/* {row.percentagePaid == '' ? '-' : '12%'} */}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.percentagePaid),
        filter: true,
        width: '180px',
      },
      {
        name: t('Payment Status'),
        cell: (row: any) => (
          <div className='my-3'>
            <label className='form-check form-switch form-check-custom form-check-success form-check-solid '>
              {row.PaymentStatus == 'Pending' ? (
                <span className='btn btn-warning mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                  {t('Pending')}
                </span>
              ) : row.PaymentStatus == 'Approved' ? (
                <span className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                  {t('Approved')}
                </span>
              ) : row.PaymentStatus == 'Rejected' ? (
                <span className='btn btn-light-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                  {t('Rejected')}
                </span>
              ) : row.PaymentStatus == 'Cancelled' ? (
                <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                  {t('Cancelled')}
                </span>
              ) : row.PaymentStatus == 'Completed' ? (
                <span className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                  {t('Completed')}
                </span>
              ) : (
                ''
              )}
            </label>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.PaymentStatus),
        filter: true,
        width: '180px',
      },
    ],
    [t]
  )

  useEffect(() => {
    yearlyInvoiceListApiCall()
    yearlyInvoiceTotalApiCall()
    document.title = 'Insayr | View Vendor Payment Management'
  }, [])

  const handlePageChange = (newPage: number) => {
    const totalPages = Math.ceil(totalRecords / limit) // Total pages based on API data only
    const newOffset = (newPage - 1) * limit
    setOffset(newOffset)

    yearlyInvoiceListApiCall(selectedYear, limit, newOffset)
  }

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setLimit(newRowsPerPage)
    yearlyInvoiceListApiCall(selectedYear, limit, offset)
  }
  const customRow = {
    invoiceCode: '', // Unique identifier to differentiate it
    documentName: '',
    invoiceCreated: '',
    totalBooking: '',
    totalRevenue: totalRevenue,
    insayrRevenue: totalInsayrRevenue,
    percentagePaid: '',
    PaymentStatus: '',
  }

  // Combine hotelList with the custom row for display
  const dataWithCustomRow = useMemo(() => {
    // Always append the custom row to the current page's data
    return [...paymentDetailList, customRow]
  }, [paymentDetailList, totalInsayrRevenue])

  return (
    <>
      <div className='container'>
        <div className='justify-content-center d-flex flex-wrap gap-5 mb-6'>
          <div className='filters'>
            <label htmlFor='SelectStatus' className='fs-4 form-label'>
              {t('Select Year')}
            </label>
            <Select
              name='selectYear'
              id='selectYear'
              placeholder={t('Select Year')}
              isSearchable={true}
              options={yearList}
              value={yearList.find((option: any) => option.value == selectedYear) || null}
              onChange={(e: any) => setSelectedYear(e.value)}
              styles={{
                container: (provided : CSSObjectWithLabel) => ({...provided, width: '100%'}),
                control: (provided : CSSObjectWithLabel) => ({...provided, minHeight: 43}),
              }}
            />
          </div>
        </div>
      </div>

      <div className='d-flex justify-content-center mb-5'>
        <div className='col-md-2 mb-3 d-flex align-items-end'>
          <button
            className='btn btn-primary mx-1'
            onClick={() => {
              yearlyInvoiceListApiCall()
              yearlyInvoiceTotalApiCall()
            }}
          >
            {t('Apply')}
          </button>
          <button className='btn btn-danger mx-1' onClick={() => clearFields()}>
            {t('Clear')}
          </button>
        </div>
      </div>

      <ToastContainer />

      <>
        <DataTable
          columns={column}
          data={dataWithCustomRow}
          pagination
          paginationServer={true}
          subHeader={true}
          subHeaderComponent={
            <CustomHeader search={searchTerm} isfoc={focus} customSearch={paymentDetailSearch} />
          }
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          paginationTotalRows={totalRecords} // Only API records, custom row is added client-side
          paginationPerPage={limit}
          paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
          paginationComponentOptions={{
            rowsPerPageText: t('Rows Per Page'),
          }}
        />
      </>
    </>
  )
}

export {ViewVendorPaymentManagement}
